import { Action, action } from "easy-peasy";

export interface AdminDashboardModel {
  dismissedProgramIsLiveAlert: boolean;

  setDismissedProgramIsAliveAlert: Action<AdminDashboardModel, any>;
}

export const dashboard: AdminDashboardModel = {
  dismissedProgramIsLiveAlert: false,

  setDismissedProgramIsAliveAlert: action((state, payload: boolean) => {
    state.dismissedProgramIsLiveAlert = payload;
  }),
};
